import { ROLES_LIST } from '@/js/constants';
export default [{
  icon: 'icon-segments',
  name: 'Segmentos',
  key: 'menu.aud.segments',
  link: '/segments',
  regex: /^\/segments/,
  roles: [ROLES_LIST.AUDIENCE_USER, ROLES_LIST.AUDIENCE_ANALYST, ROLES_LIST.AUDIENCE_ADMIN, ROLES_LIST.ORG_DATA_STEWARD],
  subItems: [{
    /* icon: 'mdi-newspaper-plus',*/
    name: 'Mis Segmentos',
    key: 'menu.aud.my_segments',
    link: '/segments/list',
    href: {
      name: 'segments'
    },
    roles: [ROLES_LIST.AUDIENCE_USER, ROLES_LIST.AUDIENCE_ANALYST, ROLES_LIST.AUDIENCE_ADMIN, ROLES_LIST.ORG_DATA_STEWARD]
  }, {
    /* icon: 'mdi-newspaper-plus',*/
    name: 'Crear Segmento',
    key: 'menu.aud.create_segment',
    link: '/segments/create',
    href: {
      name: 'new_segment'
    },
    roles: [ROLES_LIST.AUDIENCE_USER, ROLES_LIST.AUDIENCE_ANALYST, ROLES_LIST.AUDIENCE_ADMIN, ROLES_LIST.ORG_DATA_STEWARD]
  }, {
    /* icon: 'mdi-merge',*/
    name: 'Ingresar Data Propia',
    key: 'menu.aud.cross_table',
    link: '/segments/cross_table',
    href: {
      name: 'cross_table'
    },
    roles: [ROLES_LIST.AUDIENCE_USER, ROLES_LIST.AUDIENCE_ANALYST, ROLES_LIST.AUDIENCE_ADMIN, ROLES_LIST.ORG_DATA_STEWARD]
  }, {
    /* icon: 'mdi-merge',*/
    name: 'Combinar Segmentos',
    key: 'menu.aud.merge_segment',
    link: '/segments/merge_segment',
    href: {
      name: 'merge_segment'
    },
    roles: [ROLES_LIST.AUDIENCE_USER, ROLES_LIST.AUDIENCE_ANALYST, ROLES_LIST.AUDIENCE_ADMIN, ROLES_LIST.ORG_DATA_STEWARD]
  }]
}, {
  icon: 'icon-dquality',
  name: 'Campañas',
  key: 'menu.aud.campaigns',
  link: '/campaigns',
  regex: /^\/campaigns',/,
  roles: [ROLES_LIST.AUDIENCE_USER, ROLES_LIST.AUDIENCE_ANALYST, ROLES_LIST.AUDIENCE_ADMIN, ROLES_LIST.ORG_DATA_STEWARD],
  subItems: [{
    name: 'Sandbox',
    key: 'menu.aud.sandbox',
    link: '/campaigns/sandbox',
    href: {
      name: 'campaigns_sandbox'
    },
    roles: [ROLES_LIST.AUDIENCE_USER, ROLES_LIST.AUDIENCE_ANALYST, ROLES_LIST.AUDIENCE_ADMIN, ROLES_LIST.ORG_DATA_STEWARD]
  }, {
    name: 'Mis Campañas',
    key: 'menu.aud.my_campaigns',
    link: '/campaigns/list',
    href: {
      name: 'campaigns'
    },
    roles: [ROLES_LIST.AUDIENCE_USER, ROLES_LIST.AUDIENCE_ANALYST, ROLES_LIST.AUDIENCE_ADMIN, ROLES_LIST.ORG_DATA_STEWARD]
  }, {
    name: 'Historico cargas',
    key: 'menu.aud.upload_history',
    link: '/campaigns/history',
    href: {
      name: 'history'
    },
    roles: [ROLES_LIST.AUDIENCE_USER, ROLES_LIST.AUDIENCE_ANALYST, ROLES_LIST.AUDIENCE_ADMIN, ROLES_LIST.ORG_DATA_STEWARD]
  }, {
    name: 'Variables',
    key: 'menu.aud.variable',
    link: '/campaigns/variable',
    href: {
      name: 'variable'
    },
    roles: [ROLES_LIST.AUDIENCE_USER, ROLES_LIST.AUDIENCE_ANALYST, ROLES_LIST.AUDIENCE_ADMIN, ROLES_LIST.ORG_DATA_STEWARD]
  }, {
    name: 'Grupo de Variables',
    key: 'menu.aud.variable_group',
    link: '/campaigns/variable_group',
    href: {
      name: 'variable_group'
    },
    roles: [ROLES_LIST.AUDIENCE_USER, ROLES_LIST.AUDIENCE_ANALYST, ROLES_LIST.AUDIENCE_ADMIN, ROLES_LIST.ORG_DATA_STEWARD]
  }, {
    name: 'Reportes',
    key: 'menu.aud.report',
    link: '/campaigns/report',
    href: {
      name: 'reports'
    },
    roles: [ROLES_LIST.AUDIENCE_USER, ROLES_LIST.AUDIENCE_ANALYST, ROLES_LIST.AUDIENCE_ADMIN, ROLES_LIST.ORG_DATA_STEWARD]
  }]
}, {
  icon: 'icon-audiences',
  name: 'Audiencias',
  link: '/audiences',
  key: 'menu.aud.audiences',
  regex: /^\/audiences/,
  roles: [ROLES_LIST.AUDIENCE_USER, ROLES_LIST.AUDIENCE_ANALYST, ROLES_LIST.AUDIENCE_ADMIN, ROLES_LIST.ORG_DATA_STEWARD],
  subItems: [{
    /* icon: 'mdi-open-in-new',*/
    name: 'Mis Audiencias',
    key: 'menu.aud.my_audiences',
    href: {
      name: 'link_list_audiences'
    },
    link: '/audiences/list',
    roles: [ROLES_LIST.AUDIENCE_USER, ROLES_LIST.AUDIENCE_ANALYST, ROLES_LIST.AUDIENCE_ADMIN, ROLES_LIST.ORG_DATA_STEWARD]
  }, {
    /* icon: 'mdi-open-in-new',*/
    name: 'Crear Audiencia',
    href: {
      name: 'new_audience'
    },
    key: 'menu.aud.create_audience',
    link: '/audiences/create',
    roles: [ROLES_LIST.AUDIENCE_USER, ROLES_LIST.AUDIENCE_ANALYST, ROLES_LIST.AUDIENCE_ADMIN, ROLES_LIST.ORG_DATA_STEWARD]
  }
  /*{
    name: 'Imagenes Audiencia',
    href: { name: 'audience_images' },
    key: 'aud.config.titles.audience_images',
    link: '/audiences/images',
    roles: [ROLES_LIST.AUDIENCE_USER, ROLES_LIST.AUDIENCE_ANALYST, ROLES_LIST.AUDIENCE_ADMIN, ROLES_LIST.ORG_DATA_STEWARD]
  }*/]
}, {
  icon: 'mdi-ticket-percent-outline',
  name: 'Cupones',
  link: '/coupons',
  key: 'menu.aud.coupons',
  regex: /^\/coupons/,
  roles: [ROLES_LIST.AUDIENCE_USER, ROLES_LIST.AUDIENCE_ANALYST, ROLES_LIST.AUDIENCE_ADMIN, ROLES_LIST.ORG_DATA_STEWARD],
  check_flag: 'audience/has_talonone_coupons',
  subItems: [{
    /* icon: 'mdi-open-in-new',*/
    name: 'Mis Cupones',
    key: 'menu.aud.my_coupons',
    href: {
      name: 'coupons_list'
    },
    link: '/coupons/list',
    roles: [ROLES_LIST.AUDIENCE_USER, ROLES_LIST.AUDIENCE_ANALYST, ROLES_LIST.AUDIENCE_ADMIN, ROLES_LIST.ORG_DATA_STEWARD]
  }, {
    /* icon: 'mdi-open-in-new',*/
    name: 'Crear Cupones',
    href: {
      name: 'coupons_create'
    },
    key: 'menu.aud.create_coupon',
    link: '/coupons/create',
    roles: [ROLES_LIST.AUDIENCE_USER, ROLES_LIST.AUDIENCE_ANALYST, ROLES_LIST.AUDIENCE_ADMIN, ROLES_LIST.ORG_DATA_STEWARD]
  }]
}, {
  icon: 'icon-monitoring',
  name: 'Análitica Digital',
  link: '/digital_analytic',
  key: 'menu.aud.analytics',
  regex: /^\/digital_analytic/,
  roles: [ROLES_LIST.AUDIENCE_USER, ROLES_LIST.AUDIENCE_ANALYST, ROLES_LIST.AUDIENCE_ADMIN, ROLES_LIST.ORG_DATA_STEWARD],
  subItems: [{
    /* icon: 'mdi-open-in-new',*/
    name: 'Share',
    key: 'menu.aud.share',
    href: {
      name: 'link_audiences_share'
    },
    link: '/digital_analytic/share',
    roles: [ROLES_LIST.AUDIENCE_USER, ROLES_LIST.AUDIENCE_ANALYST, ROLES_LIST.AUDIENCE_ADMIN, ROLES_LIST.ORG_DATA_STEWARD]
  }, {
    /* icon: 'mdi-open-in-new',*/
    name: 'Performance',
    href: {
      name: 'link_audiences_performace'
    },
    key: 'menu.aud.performance',
    link: '/digital_analytic/performance',
    roles: [ROLES_LIST.AUDIENCE_USER, ROLES_LIST.AUDIENCE_ANALYST, ROLES_LIST.AUDIENCE_ADMIN, ROLES_LIST.ORG_DATA_STEWARD]
  }, {
    /* icon: 'mdi-open-in-new',*/
    name: 'Monetization',
    href: {
      name: 'link_audiences_monetization'
    },
    key: 'menu.aud.monetization',
    link: '/digital_analytic/monetization',
    roles: [ROLES_LIST.AUDIENCE_USER, ROLES_LIST.AUDIENCE_ANALYST, ROLES_LIST.AUDIENCE_ADMIN, ROLES_LIST.ORG_DATA_STEWARD]
  }, {
    /* icon: 'mdi-open-in-new',*/
    name: 'Omnichannel',
    href: {
      name: 'link_audiences_omnichannel'
    },
    key: 'menu.aud.omnicanal',
    link: '/digital_analytic/omnichannel',
    roles: [ROLES_LIST.AUDIENCE_USER, ROLES_LIST.AUDIENCE_ANALYST, ROLES_LIST.AUDIENCE_ADMIN, ROLES_LIST.ORG_DATA_STEWARD]
  }]
}, {
  icon: 'icon-requests',
  name: 'Exceptions',
  link: '/configuration/exception',
  key: 'menu.aud.exception',
  roles: [ROLES_LIST.AUDIENCE_USER, ROLES_LIST.AUDIENCE_ANALYST, ROLES_LIST.AUDIENCE_ADMIN, ROLES_LIST.ORG_DATA_STEWARD],
  href: {
    name: 'exception'
  }
}, {
  icon: 'icon-config',
  name: 'Configuration',
  link: '/configuration/flags',
  key: 'menu.aud.config_flags',
  roles: [ROLES_LIST.AUDIENCE_ADMIN],
  href: {
    name: 'config_flags'
  }
}];